import { HttpClient, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { switchMap } from "rxjs/operators";
import { environment } from 'src/environments/environment';


@Injectable()
export class FormReplayProtectionInterceptor implements HttpInterceptor {
    constructor(private http: HttpClient) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.method === 'POST') {
            // fetch a fresh token before every POST
            return this.http.get<{token: string}>(`${environment.apiUrl}/RequestToken/generate`)
                .pipe(
                    switchMap(response => {
                        const cloned = req.clone({
                            headers: req.headers.set('X-Request-Token', response.token)
                        });
                        return next.handle(cloned);
                    })
                );
        }
        return next.handle(req);
    }
}